module.exports = __webpack_public_path__ + "img/797fca3.jpg";